<div class="flex justify-center max-w-[1008px] w-full mt-4 py-2" *transloco="let t; prefix: ''">
  <ul class="stepper-indicator-wrapper items-end ">
    <li *ngFor="let step of Steps; let i = index"
      class="step gap-2 justify-center min-w-[140px] !text-[10px]" 
      [ngClass]="{ completed: StepNo > i + 1, active: StepNo === i + 1 }"
    [ngStyle]="{ '--tw-before-width': ((i + 1) / Steps.length) * 100 + '%' }">
      {{ t(step) }}
      <span> {{ i + 1 }} / {{ Steps.length }} </span>
    </li>
  </ul>
</div>